import { InvoiceDetailModel } from './invoice-detail.model';

export class InvoiceDetailSubscriptionModel extends InvoiceDetailModel {
  public trm_start_date: Date = undefined;
  public trm_end_date: Date = undefined;

  constructor(source?: any) {
    super(source);

    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'trm_start_date':
            case 'trm_end_date':
              var dateKey: 'trm_start_date' | 'trm_end_date' = <any>key;
              if (source[dateKey] == null || source[dateKey] == undefined || source[dateKey] == '') {
                this[dateKey] = null;
              } else {
                this[dateKey] = new Date(source[dateKey]);
              }
          }
        }
      }
    }
  }
}
